'use clent';

import { Divider, IconName, TrilogyColor } from '@bytel/trilogy-react-ts';

export default function HomeDivider() {
    return (
        <div id='bboxDivider'>
            <Divider iconName={IconName.PLUS} backgroundColor={TrilogyColor.SECONDARY20} color={TrilogyColor.GREY40} />
        </div>
    );
}
